import MainLayout from '../layouts/main';
import ExamContainer from './container';

function ExamPage() {
  return (
    <MainLayout title={EXAM_PAGE_TITLE} stickyHeader={false}>
      <ExamContainer />
    </MainLayout>
  );
}

export const EXAM_PAGE_TITLE = 'آزمون';

export default ExamPage;
